export const contactsData = {
    email: 'ritikmasand10@gmail.com',
    phone: '+918178592777',
    address: 'Dwarka,New Delhi ',

    sheetAPI: ''
}